import { useEffect, useState } from 'react';
import AscendingK from '../components/AscendingK';
import { Icons } from '../components/Icons';
import { getApiBaseUrl } from '../lib/api';
import { getPublicCardUrl } from '../lib/site';
import { nameToSlug } from '../utils/validation';

export default function CardPage({ user }) {
  const slug = user.slug || nameToSlug(user.name);
  const [qrUrl, setQrUrl] = useState('');
  const publicCardUrl = getPublicCardUrl(slug);

  useEffect(() => {
    const token = localStorage.getItem('connektedin_token');
    if (!token) {
      return undefined;
    }

    let active = true;
    let objectUrl = '';

    fetch(`${getApiBaseUrl()}/users/me/qr`, {
      headers: { Authorization: `Bearer ${token}` },
      cache: 'no-store'
    })
      .then((response) => response.blob())
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (active) {
          setQrUrl(objectUrl);
        }
      });

    return () => {
      active = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [slug, user.logo, user.photo]);

  return (
    <>
      <div className="page-header">
        <div className="mono" style={{ marginBottom: 8 }}>Your Card</div>
        <h1 className="page-title">
          Share your <em>card</em>.
        </h1>
        <p className="page-subtitle">Show this QR code to anyone - they&apos;ll land on your scan page.</p>
      </div>

      <div className="page-body">
        <div className="qr-card-container animate-fadeUp">
          <div className="qr-card-header">
            <div>
              <div className="qr-card-name">{user.name}</div>
              <div className="qr-card-role">
                {user.title}
                {user.company ? ` - ${user.company}` : ''}
              </div>
            </div>
            <AscendingK size={20} color="#C9A961" />
          </div>

          <div className="qr-placeholder">
            {qrUrl ? (
              <img src={qrUrl} alt={`QR code for ${user.name}`} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 24 }} />
            ) : (
              <div className="qr-hint">
                Generating QR...
                <br /><br />
                <span style={{ color: 'var(--brand)', fontWeight: 500 }}>
                  {publicCardUrl}
                </span>
              </div>
            )}
            <div className="qr-watermark">
              <AscendingK size={14} color="#D4CFC2" />
            </div>
          </div>

          <div className="qr-card-url">{publicCardUrl}</div>

          <div className="qr-actions">
            <button className="btn btn-gold btn-full" style={{ padding: 14 }} onClick={() => qrUrl && window.open(qrUrl, '_blank')}>
              {Icons.download} Download QR Image
            </button>
            <button
              className="btn btn-outline btn-full"
              style={{ padding: 14, borderColor: 'rgba(245,242,235,0.2)', color: 'var(--paper)' }}
              disabled
            >
              Wallet Passes Coming Soon
            </button>
          </div>
        </div>

        <div style={{ maxWidth: 380, margin: '24px auto 0', textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
            Your QR code will use{' '}
            <strong>
              {user.photo ? 'your profile photo' : user.logo ? 'your company logo' : 'a default pattern'}
            </strong>{' '}
            as the background, with the Connekted&middot;in mark watermarked at the bottom right.
          </p>
        </div>
      </div>
    </>
  );
}
